import React from 'react';
import Select from './Select';

function SDSForm(props) {
    const {
        isLoading,
        countriesList,
        languagesList,
        selectedCountryId,
        selectedLanguageId,
        handleCountryChange,
        handleLanguageChange,
        handleFindSds,
        errorCountries,
        errorLanguages
    } = props;

    const isSubmitButtonDisabled = isLoading || countriesList.length <= 0 || languagesList.length <= 0 || errorCountries || errorLanguages;

    return (
        <form className="simple" action="" method="get">
            <div className="sds-widget__item">
                <Select
                    labelText="Select country"
                    name="country"
                    options={countriesList}
                    selectedOption={selectedCountryId}
                    onChange={handleCountryChange}
                    error={errorCountries}
                    errorText="Could not find available countries"
                />
            </div>
            <div className="sds-widget__item">
                <Select
                    labelText="Select language"
                    name="language"
                    options={languagesList}
                    selectedOption={selectedLanguageId}
                    onChange={handleLanguageChange}
                    error={errorLanguages}
                    errorText="Could not find available languages"
                />
            </div>
            <div className="sds-widget__item">
                <button
                    className="sds-widget__submit-btn btn btn--primary btn--outline"
                    onClick={handleFindSds}
                    disabled={isSubmitButtonDisabled}
                >
                    Find available SDS
                </button>
            </div>
        </form>
    )
}

export default SDSForm;